import loglevel from "loglevel";

loglevel.setLevel("error");

export default loglevel.getLogger("openlogin");
